import { render } from "./NewOrderLot.vue?vue&type=template&id=18dc18b7&scoped=true"
import script from "./NewOrderLot.vue?vue&type=script&lang=js"
export * from "./NewOrderLot.vue?vue&type=script&lang=js"

import "./NewOrderLot.vue?vue&type=style&index=0&id=18dc18b7&lang=css"
import "./NewOrderLot.vue?vue&type=style&index=1&id=18dc18b7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18dc18b7"]])

export default __exports__